const input = require('../input/input');

const password = Object.assign({}, input, {
    subelements: {
        repeat: null,
        randomGeneratorTrigger: null,
        validationMessage: null,
        visibilityToggler: null,
        // Outer widget host element. Only emitted by the template when
        // makeVisible or showStrength is enabled (i.e. when the password-meter
        // widget is actually needed). hasSubelement() detects its presence.
        widgetHolder: null
    },
    validationTriggeringEvents: ['input', 'keyup'],

    init: function () {
        input.init.call(this);

        // Initialise the password-meter widget when the template emitted the
        // wrapper marker. The widget owns the visibility toggle (eye icon)
        // and the strength-meter highlight bar. Under metronic_8 the adapter
        // wraps KTPasswordMeter; under bootstrap5 the adapter is a stub
        // that throws (no Bootstrap-native equivalent).
        if (this.hasSubelement('widgetHolder')) {
            this.hm.behaviors.passwordMeter.create(this.subelements.widgetHolder);
        }

        if (this.hasSubelement('repeat')) {
            this.subelements.repeat.addEventListener('keyup', () => {
                this.startTimer('validation', () => {
                    this.validate();
                })
            });
        }

        if (this.hasSubelement('randomGeneratorTrigger')) {
            this.subelements.randomGeneratorTrigger.addEventListener('click', (ev) => {
                ev.preventDefault();
                this.doRandomGenerate(); 
                return false;
            });
        }
    },

    doRandomGenerate: function () {
        //['required','min_length','min_numbers','min_symbols','min_uppercase','min_lowercase','passwords_dont_match'],

        let rules = this.hm.validator.getRules(this.formId, this.id);
        let min_length = typeof rules.min_length !== typeof undefined ? rules.min_length.value : 12;

        min_length += Math.floor(Math.random() * 3);

        let min_numbers = typeof rules.min_numbers !== typeof undefined ? rules.min_numbers.value : 2;

        let min_symbols = typeof rules.min_symbols !== typeof undefined ? rules.min_symbols.value : 2;
        let min_lowercase = typeof rules.min_lowercase !== typeof undefined ? rules.min_lowercase.value : 2;
        let min_uppercase = typeof rules.min_uppercase !== typeof undefined ? rules.min_uppercase.value : 2;

        let noLowercase = 0;
        let noSymbols = 0;
        let noUppercase = 0;
        let noDigits = 0;

        let password = '';

        while (noLowercase < min_lowercase || noUppercase < min_uppercase || noDigits < min_numbers || noSymbols < min_symbols || password.length < min_length + 8) {
            let whatToGenerate = Math.floor(Math.random() * 50) % 4;

            switch (whatToGenerate) {
                case 0:
                    //lowercase    
                    if (noLowercase < min_length - min_uppercase - min_numbers - min_symbols + 8) {
                        //97 to 122
                        let charCode = Math.floor(Math.random() * 100) % 26 + 97;
                        let char = String.fromCharCode(charCode);
                        password += char;
                        noLowercase++;
                    }
                    break;

                case 1:
                    //uppercase
                    if (noUppercase < min_uppercase + 8) {
                        //65 to 90
                        let charCode = Math.floor(Math.random() * 100) % 26 + 65;
                        let char = String.fromCharCode(charCode);
                        password += char;
                        noUppercase++;
                    }
                    break;

                case 2:
                    //digits
                    if (noDigits < min_numbers + 8) {
                        //48 to 57
                        let charCode = Math.floor(Math.random() * 100) % 10 + 48;
                        let char = String.fromCharCode(charCode);
                        password += char;
                        noDigits++;
                    }
                    break;

                case 3:
                    //symbols 
                    if (noSymbols < min_symbols + 4 && password.length > 2) {
                        let symbolsCodes = [33, 35, 36, 38, 40, 41, 42, 43, 44, 45, 46, 58, 59, 61, 63, 64, 91, 92, 93];
                        //48 to 57
                        let charCode = Math.floor(Math.random() * 100) % symbolsCodes.length;
                        let char = String.fromCharCode(symbolsCodes[charCode]);
                        password += char;
                        noSymbols++;
                    }
                    break;
            }
        }

        this.setValue(password);
        this.subelements.repeat.value = password;
        let event = new Event('input');

        this.element.dispatchEvent(event);
    }
});

module.exports = password;
